import _slicedToArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.regexp.replace.js";

// Locate all json files deeply
var files = require.context('.', true, /^.*\.json$/);

var messages = {};
files.keys().forEach(function (key) {
  // Determine the locale and name from the path
  var _key$replace$split$0$ = key.replace('./', '').split('.')[0].split('/'),
      _key$replace$split$0$2 = _slicedToArray(_key$replace$split$0$, 2),
      locale = _key$replace$split$0$2[0],
      name = _key$replace$split$0$2[1];

  messages[locale] = messages[locale] || {};
  messages[locale][name] = files(key);
});
export default messages;